<template>
	<div class="card">
		<div class="card-body px-0">
			<div class="d-flex justify-content-between align-items-center mb-3">
				<div v-if="item.status" class="">
					<div class="badge badge-status badge-status-sm" :style="{
						'color': resolvePath(item, 'status.color'),
						'background-color': $root.$helper.color.convertHex(resolvePath(item, 'status.color'))
					}">
						<span>{{ resolvePath(item, 'status.name') }}</span>
					</div>
				</div>
				<div class="d-flex">
					<div class="">
						<button type="button"
							class="btn btn-link shadow-none text-decoration-none text-nowrap min-w-auto p-0 m-0"
							@click.prevent="selectFeature(item)">
							<span class="text-btn-link">{{ $t(txtLinkMap) }}</span>
						</button>
					</div>
				</div>
			</div>
			<div v-if="item.type" class="title">
				{{ resolvePath(item, 'type.name') }}
			</div>
			<div class="row no-gutters">
				<div class="col">
					<div class="form-group">
						<p class="label">
							{{ $t(labelCode) }}
						</p>
						<p>
							{{ resolvePath(item, 'code') }}
						</p>
					</div>
				</div>
				<div class="col" v-if="feature">
					<div class="form-group">
						<p class="label">
							{{ $t(labelFeature) }}
						</p>
						<p>
							{{ feature }}
						</p>
					</div>
				</div>
				<div class="col">
					<div class="form-group">
						<p class="label">
							{{ $t(labelCreatedAt) }}
						</p>
						<p>
							{{ createdAt }}
						</p>
					</div>
				</div>
			</div>
			<div class="row no-gutters" v-if="address">
				<div class="col">
					<div class="form-group">
						<p class="label">
							{{ $t(labelAddress) }}
						</p>
						<p>
							{{ address }}
						</p>
					</div>
				</div>
			</div>
			<div class="row no-gutters" v-if="description">
				<div class="col">
					<div class="form-group">
						<p class="label">
							{{ $t(labelDescription) }}
						</p>
						<transition name="fade">
							<read-more class="read-more" :moreStr="$t('global.read-more')"
								:lessStr="$t('global.read-less')" :text="description" :maxChars="186">
							</read-more>
						</transition>
					</div>
				</div>
			</div>
			<div v-if="daysOverdue" class="row no-gutters">
				<div class="col">
					<div class="alert alert-danger small text-lowercase font-weight-bold">
						{{ txtDaysOverdue }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { detectMobile } from "@config/browser";
import { resolvePath } from "@config/utils";
import { EVENTS } from '@/app/shared/utils/constants';

export default {
	props: {
		item: {
			type: Object,
			default: {},
		},
		propertyValidateLinkMap: {
			type: String,
			default: 'on_map',
		},
		txtLinkMap: {
			type: String,
			default: 'View on map',
		},
		labelCode: {
			type: String,
			default: 'Code',
		},
		labelFeature: {
			type: String,
			default: 'Element',
		},
		labelAddress: {
			type: String,
			default: 'Address',
		},
		labelDescription: {
			type: String,
			default: 'Description',
		},
		labelCreatedAt: {
			type: String,
			default: 'Created at',
		},
		labelDaysOverdue: {
			type: String,
			default: 'Days late',
		},
		eventSelect: {
			type: String,
			default: EVENTS.SELECT_FEATURE,
		},
	},
	computed: {
		isMobile: {
            cache: false,
            get(){ return detectMobile() }
        },
		feature() {
			return this.resolvePath(this.item, 'feature.label');
		},
		createdAt() {
			let dt = this.resolvePath(this.item, 'created_at');
			return dt ? moment(dt, "YYYY-MM-DD hh:mm:ss").format('DD-MM-YYYY') : null;
		},
		description() {
			return this.resolvePath(this.item, 'description');
		},
		address() {
			return this.resolvePath(this.item, 'address') || this.resolvePath(this.item, 'full_address')
		},
		daysOverdue() {
			return this.resolvePath(this.item, 'days_overdue');
		},
		txtDaysOverdue() {
			let num = this.daysOverdue;
			return num + ' ' + this.$tc(this.labelDaysOverdue, num);
		},
		// já não é necessário pois foram corrigidas as regras backend!!
		// visibleOnMap() {
		// 	if (this.propertyValidateLinkMap) {
		// 		return this.resolvePath(this.item, this.propertyValidateLinkMap) ?? true;
		// 	}
		// 	return true;
		// }
	},
	methods: {
		selectFeature(item) {
			if (this.isMobile) {
				this.closeModal();
			}
			this.$emit('selectItem', item);

			if(this.eventSelect) {
				this.$eventBus.publish(this.moduleCode, this.eventSelect, { code: item.code, item: item, detail: true });
			}
		},
		resolvePath(obj, path) {
			return resolvePath(obj, path);
		},
	}
}
</script>